module.exports = __webpack_public_path__ + "img/tool-parallelogram.d05d86e7.svg";